<template>
  <div id="streetViewContainer">
    <div class="loading-wrapper" v-if="ladybugSrc1 && !c1SuccessfulLoad">
      <fa :icon="['fas', 'spinner']" spin class="loading-icon" />
      <p class="loading-text">Loading image...</p>
    </div>
    <div class="wrapper" v-show="ladybugSrc1 && c1SuccessfulLoad">
      <div id="streetViewBottom" class="box" 
        @click="openImgInNewTab('ladybugStreetViewC1')">
        <h5 class="image-text top-left-text unselectable">
          {{ ladybugImageryAttributeData.datetime }}
        </h5>
        <h5 class="image-text top-right-text unselectable">C1</h5>
        <h5 class="image-text bottom-right-text unselectable">
          {{ ladybugImageryAttributeData.processing_index }}
        </h5>
        <img
          id="ladybugStreetViewC1"
          :src="ladybugSrc1"
          class="clickable"
          alt="C1"
          :height="bImg1Height"
          :width="bImg1Width"
          @load="imageFound()"/>
      </div>
      <div id="imageryRotateDiv1" class="imageryRotateDiv">
        <button 
          id="imageryRotateButton1" 
          class="imageryRotateButton" 
          size="sm" 
          title="image rotate"
          @click="imageRotate('ladybugStreetViewC1')"
        >
          <span> <fa :icon="['fas', 'sync-alt']" style="color: white;" /> </span>
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .image-text {
          position: absolute;
          color: white;
          text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
          z-index: 100;
  }
  .bottom-right-text {
          bottom: 0px;
          right: 2%;
  }
  .top-left-text {
          top: 8px;
          left: 2%;
  }
  .top-right-text {
          top: 8px;
          right: 2%;
  }
  .unselectable {
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  #streetViewContainer {
    position: relative;
    text-align: center;
    border-radius: 10px;
  }
  #streetViewBottom {
          position: relative;
          border-radius: 10px;
  }
  #streetViewTop {
          position: relative;
  }
  .imageryRotateButton {
    /* box-shadow: 1px 1px 1px 1px #1b1c1d;     */
    position: relative;
    z-index: 999;  
    background: rgba(85, 85, 83, 0.932);
  }
  .imageryRotateDiv {
    position: relative;    
    text-align: end;
    margin-top: -17rem;
    margin-right: 0.5rem;
  }
  button {
    position: relative;
    width: 1.5rem;
    height: 1.5rem;
    margin-top: -2em;
    background: none;    
    cursor: pointer;
    padding: 0;
    box-sizing: content-box;
    border: 2px solid transparent;
    box-shadow: 2px 2px 2px #1b1c1d;
    font-size: 1rem;
    text-align: center;    
  }
  button::before,
  button::after,
  span::before,
  span::after {
          display: block;
          content: "";
          width: 8px;
          height: 8px;
          position: absolute;
  }
  button::before {
          top: -2px;
          left: -2px;
          border-top: 2.5px solid white;
          border-left: 2.5px solid white;
          border-radius: 2px ;
          transition: 0.5s all;
  }
  button::after {
          top: -2px;
          right: -2px;
          border-top: 2.5px solid white;
          border-right: 2.5px solid white;
          border-radius: 2px ;
          transition: 0.5s all;
  }
  span::before {
          bottom: -2px;
          left: -2px;
          border-bottom: 2.5px solid white;
          border-left: 2.5px solid white;
          border-radius: 2px ;
          transition: 0.5s all;
  }
  span::after {
          bottom: -2px;
          right: -2px;
          border-bottom: 2.5px solid white;
          border-right: 2.5px solid white;
          border-radius: 2px ;
          transition: 0.5s all;
  }
  button:hover::before,
  button:hover::after {
          width: 1.5rem;
          height: 1.5rem;
  }
  button:hover span::before,
  button:hover span::after {
          width: 1.5rem;
          height: 1.5rem;
  }

  .loading-wrapper {
    height: 20rem;
    width: 30rem;
    background-color: rgb(0, 0, 0, 0.5);
    border: 2px solid black;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-bottom: 2px;
    gap: 10px;
  }
  .loading-icon {
    font-size: 2rem;
    color: whitesmoke;
    margin-bottom: 0.5rem;
  }
  .loading-text {
    color: whitesmoke;
    margin: 0;
    font-size: 0.9rem;
    margin-bottom: 4px;
  }

  .wrapper {
    height: 20rem;
    width: 30rem;
    margin-bottom: 2px;
  }

  .box {
    border: none;
    position: absolute;
    width: 100%;
    height: 100%;   
    overflow: hidden;
    color: #1b1c1d;
  }

  .box img {
    width: 100%;
    height: 100%;
  }

  .portrait {
    padding-left: 17%;
    padding-right: 17%;
  }
</style>

<script>
export default {
  name: 'MMP_ANSI_LadybugStreetView',
  props: ['ladybugSrc1', 'ladybugImageryAttributeData'],
  data() {
    return {
      bImg1Height: 350,
      bImg1Width: 500,
      originalRatio: 0.6666666666666666,
      c1SuccessfulLoad: false,
      streetViewChange: false,
      ladybugStreetViewC1Obj:{
        rotated: false,
        rotationAngle : 0,
      }   
    }
  },
  methods: {
    imageFound() {
      this.c1SuccessfulLoad = true
      this.processDimensions()
      this.$forceUpdate()
    },
    openImgInNewTab(imageId) {
      var imageObj = document.getElementById(imageId)
      var url = imageObj.src
      var rotationAngle = ''

      rotationAngle = this.ladybugStreetViewC1Obj.rotationAngle

      var conditionalClass = (rotationAngle == 90 || rotationAngle == 270) ?
        `<div class="box portrait">`
        :
        `<div class="box">`

      const htmlContent = `
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Rotated Image</title>
        <style>
          body {
            margin: 1px;
            position: fixed;
            display: block;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            overflow: hidden;            
          }
          .wrapper {
              height: 100%;
              width: 100%;
              margin-bottom: 5px;
              background: rgba(6, 47, 86, 0.65);
              overflow: hidden;
            }
          
            .box {
              border: none;
              position: relative;
              width: 100%;
              height: 100%;
              overflow: hidden;
              color: #1b1c1d;
            }
          
            .portrait {
              position: fixed;
              padding-left: 30%;
              max-width: 47%;
              max-height: 100%;
              object-fit: cover;
            }

          img {
            height: 100%;
            width: 100%;
            transform: rotate(${rotationAngle}deg);  
            overflow-clip-margin: content-box;
            overflow: hidden;         
          }
        </style>
      </head>
      <body>
        <div class="wrapper">`
        +
        conditionalClass
        +
        ` <img src="${url}" alt="Rotated Image">
          </div>
        </div>
      </body>
      </html>
      `

      const newTab = window.open()
      newTab.document.open()
      newTab.document.write(htmlContent)
      newTab.document.close();
    },
    // REFACTOR SUGGESTION: fn not used and url is never defined...? Adding it as a parameter to get test cases to pass
    openCanvasImage(url) {
      if (document.getElementById("newImg")) {
        document.body.removeChild("newImg")
      }

      window.open(url, '_blank')
    },
    processDimensions() {
      let id = 'ladybugStreetViewC1'
      let element = document.getElementById(id)
      let originalHeight = element.naturalHeight
      let originalWidth = element.naturalWidth
      let divisor = originalHeight > 1080 && originalWidth > 1920 ? 6 : 4
      let scaledHeight = originalHeight / divisor
      let scaledWidth = originalWidth / divisor

      this.bImg1Height = scaledHeight
      this.bImg1Width = scaledWidth
    },
    imageRotate(imageId) {
      // Access DOM element object
      const rotated = document.getElementById(imageId)
      this.rotateImage(rotated, this.ladybugStreetViewC1Obj)
    },
    rotateImage(rotated, imageRotationObject) {
      // How much to rotate the image at a time
      const angle = 90
      // Ensure angle range of 0 to 359 with "%" operator,
      // e.g., 450 -> 90, 360 -> 0, 540 -> 180, etc.
      imageRotationObject.rotationAngle = (imageRotationObject.rotationAngle + angle) % 360
      rotated.style.transform = `rotate(${imageRotationObject.rotationAngle}deg)`

      var rotationRatio = rotated.getBoundingClientRect().height / rotated.getBoundingClientRect().width

      if (rotationRatio > this.originalRatio) {
        rotated.classList.add("portrait");
      }
      else {
        rotated.classList.remove("portrait");
      }       
    }
  },
  updated() {
    let changed = this.streetViewChange
    this.streetViewChange = !this.streetViewChange
    if (changed) {
      this.$emit(
        'streetViewChanged',
        `width: ${Math.max(this.bImg1Width, 0)}px;
        height: ${Math.max(this.bImg1Height, 0)}px;`
      )
    }
  },
  watch: {
    ladybugSrc1: function (newValue, oldValue) {
      if (!newValue) {
        this.bImg1Height = 350
        this.bImg1Width = 500
      } else {
        this.c1SuccessfulLoad = false
        this.streetViewChange = true
        this.processDimensions()
      }
    }
  }
}
</script>
